import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { reduxForm, propTypes, Field, SubmissionError } from 'redux-form'

import actions from '../../redux/actions'
import TextInputForm from 'components/input/text/text_input_form'
import { localize } from 'helpers/translator'

class CodeForm extends Component {

	constructor(props) {
		super(props)
		this.state = {
			shouldDisplayUppercase: false,
		}
		this.getMessage = this.getMessage.bind(this)
		this.getStatus = this.getStatus.bind(this)
		this.handleOnChange = this.handleOnChange.bind(this)
	}

	componentDidMount() {
		if (this.props.autoFill) {
			if (this.props.autoFill.send === true) {
				this.props.actions.validateCodeForm(this.props.uid, this.props.autoFill.val)
			}
		}
	}

	shouldComponentUpdate() {
		/*if (this.props.fields.codeField.value !== nextProps.fields.codeField.value) {
			this.props.actions.resetCodeFormValidations(this.props.uid)
		}*/
		return true
	}

	getMessage(field) {
		return localize(field.error || this.props.message)
	}

	getStatus(field) {
		return (field.error)?'error':this.props.status
	}

	handleOnChange(e) {
		this.setState({
			shouldDisplayUppercase: !!e.target.value,
		})
	}

	render() {

		const {handleSubmit, submitting} = this.props

		const handlePinSubmit = values => new Promise((resolve, reject) => {
			this.props.actions.validateCodeForm(this.props.uid, values.codeField, resolve, reject)
		})
			.then(() => {
			}).catch(function(err) {
				throw new SubmissionError({...err})
			})

		const buttonProps = {
			type: 'submit',
			disabled: submitting,
		}

		if (submitting) {
			Object.assign(buttonProps, { disabled: true })
		}

		return (
			<div>
				<form onSubmit={handleSubmit(handlePinSubmit)}
				>
					<Field
						name="codeField"
						component={TextInputForm}
						type="text"
						onChange={this.handleOnChange}
						props={{
							placeholder: this.props.placeholder,
							maxLength: this.props.maxLength,
							activeStyle: this.props.activeStyle,
							uppercase: this.props.shouldDisplayUppercase && this.state.shouldDisplayUppercase,
							autoComplete: 'off',
							boxType: 'withButton',
							button: {
								props: buttonProps,
								data: this.props.button.text,
							},
							color: this.props.color,
							icons: this.props.icons,
							getMessage: this.getMessage,
							fieldStatus: this.getStatus,
						}}
					/>
				</form>
			</div>
		)

	}

}

CodeForm.defaultProps = {
	activeStyle: true,
	shouldDisplayUppercase: false,
	placeholder: '',
}

CodeForm.propTypes = {
	handleSubmit: PropTypes.func,
	actions: PropTypes.object,
	...propTypes,
}

const DecoratedCodeForm = reduxForm({
	form: 'CodeForm',
	fields: ['codeField'],
	enableReinitialize: true,
})(CodeForm)

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch),
	}
}

export default connect(null, mapDispatchToProps)(DecoratedCodeForm)
